import { useTranslation } from 'react-i18next';
import { EApiType, EDataTableType, EModuleType } from '../../../data/Constants';
import { MaintenanceTable } from '../../Layouts/DataTable';
import { useApiError } from '../../../hooks';
import { formatStructuredLogContent } from '../../Helper/DataTableHelper';
import {
  getProductRelease,
  retriggerProductRelease,
} from '../../../store/states/ProductReleaseSlice';
import type { IManagementProps } from '../../../../types';
import { ProductReleaseApi } from 'api/ProductReleaseApi';

export const ProductReleaseManagement = (props: IManagementProps) => {
  const { t } = useTranslation();
  const errorElement = useApiError(EApiType.NotificationKey);

  if (errorElement) {
    return errorElement;
  }

  return (
    <>
      <h3 className="mainHeader"> {t('labels.releaseManagement')}</h3>
      <MaintenanceTable
        token={props.token}
        type={EDataTableType.ProductRelease}
        getDataList={getProductRelease}
        moduleType={EModuleType.Notifications}
        getLogContent={formatStructuredLogContent}
        retrigger={retriggerProductRelease}
        download={ProductReleaseApi.downloadProductContents}
      />
    </>
  );
};
